export default function RouteFallback() {
  return (
    <div className="p-8 text-sm text-slate-500" role="status" aria-live="polite" data-testid="route-loading">
      <div className="h-1 w-40 rounded bg-slate-200 overflow-hidden"><div className="h-full w-1/3 bg-sky-500 animate-pulse" /></div>
      <div className="mt-3">Loading…</div>
    </div>
  );
}
